module.exports = __webpack_public_path__ + "img/icon104.874615d3.png";